import   React                     ,
       { useEffect                 ,
         useState                  }  from "react";
import   classNames                   from 'classnames';

import   styles                       from './RedirectionStats.module.scss';

import   AnimatedWaitingIcon2         from '../../widget/animations/animatedWaitingIcon2';

	 
import { groupData                 ,
         generateStats             ,
         generateChartData         ,
         GroupedData               ,
         ChartData                 ,
         initializedGroupedData    ,
         completeGroupData         }  from "../../../dataTypes/dataSetManagment/regroupData";		 
		 
import { Coordinate                }  from '../../../dataTypes/geolocationManagment/types';

import { convertDateToString       ,
         convertStringToDate       ,
         timeStepNames             ,
         timeStepTitles            , 
  		 roundDate                 }  from '../../../dataTypes/timeManagment/utils';

import   CustomerFrontEventList       from "./CustomerFrontEventList";

import { UrlRedirectionEvent       ,
         GetSessionsParams         }  from '../../../dataTypes/customerFrontEventManagment/types';

import { getUrlRedirectionEvents   ,
		 computeActivity           ,
         computeActivityEvolution  }  from '../../../dataTypes/customerFrontEventManagment/utils';


interface RedirectionStatsProps {
  height? : string;
}

export const RedirectionStats: React.FC<RedirectionStatsProps> = ({ height = "100vh" }) => {

  const now                 = new Date();
  const startOfYesterday    = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0);
  const startOfTomorrow     = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);

  const startOfTwoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1, 0, 0, 0);

  const [ urlRedirectionEventList         , setUrlRedirectionEventList         ] = useState<UrlRedirectionEvent[]>([]);
  const [ filteredUrlRedirectionEventList , setFilteredUrlRedirectionEventList ] = useState<UrlRedirectionEvent[]>([]);
  const [ coordinates                     , setCoordinates                     ] = useState<Coordinate[]>([]);
  
  const [ startDate                       , setStartDate                       ] = useState<Date | null>(startOfTwoMonthsAgo);
  const [ endDate                         , setEndDate                         ] = useState<Date | null>(startOfTomorrow);
  const [ filterName                      , setFilterName                      ] = useState("");
  const [ timeStep                        , setTimeStep                        ] = useState<string>("1 jour");
  const [ showWaitingIcon                 , setShowWaitingIcon                 ] = useState(false);

  const [ groupedData                     , setGroupedData                     ] = useState<GroupedData<UrlRedirectionEvent>>(initializedGroupedData<UrlRedirectionEvent>()) 
  const [ chartData                       , setChartData                       ] = useState<ChartData[]>([])


  const fetchUrlRedirectionList = async (params: GetSessionsParams = {}) => {

    try
     {
      setShowWaitingIcon(true);

      const updatedParams: GetSessionsParams = {
        ...params,
        beginningDate : startDate ?? startOfYesterday,
        endingDate    : endDate   ?? startOfTomorrow
      };

      const events = await getUrlRedirectionEvents (updatedParams);

      console.log ('fetchUrlRedirectionList', events)

      setUrlRedirectionEventList (events);
      setFilteredUrlRedirectionEventList (events);
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des events :", error);
     }
    finally
     {
      setShowWaitingIcon(false);
     }
  };

  const getGroupKey = (timeStep: string) => {

    switch (timeStep)
      {
       case "1 minute"   : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "mm", 1), "yyyy/MM/dd HH:mm")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                                  });

       case "5 minutes"  : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(  roundDate (event.eventDate!, "mm", 5) , "yyyy/MM/dd HH:mm")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                                  });

       case "10 minutes" : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString( roundDate (event.eventDate!, "mm", 10) , "yyyy/MM/dd HH:mm")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                                  });

       case "1 heure"    : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "HH", 1), "yyyy/MM/dd HH")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                                  });

       case "6 heures"   : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "HH", 6), "yyyy/MM/dd HH")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                                  });

       case "12 heures"  : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "HH", 12), "yyyy/MM/dd HH")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                                  });

       case "1 jour"     : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "dd", 1), "yyyy/MM/dd")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                                  });

       case "1 semaine"  : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "dd", 7), "yyyy/MM/dd")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                                  });

       case "2 semaines" : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "HH", 14), "yyyy/MM/dd")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                                  });

       case "1 mois"     : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "MM", 1), "yyyy/MM")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                                  });

       case "6 mois"     : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "MM", 6), "yyyy/MM")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                                  });

       case "1 an"       : return (event: UrlRedirectionEvent) => ({
                                                                         key      : `${convertDateToString(roundDate (event.eventDate!, "yyyy", 1), "yyyy")}`,
                                                                         renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy"), "yyyy")}`,
                                                                  });

       default           : throw new Error(`Unsupported timeStep: ${timeStep}`);
      }
  };

  const getRenderer = (val: Date): string => {

    switch (timeStep)
      {
       case "1 minute"   : return `${convertDateToString(val, "HH:mm",'')}`
       case "5 minutes"  : return `${convertDateToString(val, "HH:mm",'')}`
       case "10 minutes" : return `${convertDateToString(val, "HH:mm",'')}`
       case "1 heure"    : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "6 heures"   : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "12 heures"  : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "1 jour"     : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 semaine"  : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "2 semaines" : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "6 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "1 an"       : return `${convertDateToString(val, "yyyy",'')}`
       default           : throw new Error(`Unsupported timeStep: ${timeStep}`)
      }
  };

  useEffect(() => {
    fetchUrlRedirectionList();
  }, [startDate, endDate]);

  useEffect(() => {

    const coords = filteredUrlRedirectionEventList.map(event => ({
        lat   : event.lat  || 0,
        lng   : event.lon  || 0,
        info1 : convertDateToString (event.eventDate, 'dd/MM/yyyy HH:mm:ss' ), // session.ipAddress     || "N/A",
        info2 : '' ,  // `${session.userFirstname || "N/A"} ${session.userLastname || "N/A"}`,
		color : 'violet'
      }));

    setCoordinates(coords);

    const groupedDataTemp    = groupData<UrlRedirectionEvent> (filteredUrlRedirectionEventList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<UrlRedirectionEvent>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<UrlRedirectionEvent>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<UrlRedirectionEvent> ( completedGroupData , () => 1 , (a, b) => a + b );
    const chartDataTemp = generateChartData<UrlRedirectionEvent> ( statsResult, completedGroupData);

    console.log ( "filteredUrlRedirectionSessionList : " , filteredUrlRedirectionEventList )
    console.log ( "getGroupKey                       : " , getGroupKey(timeStep)           )
    console.log ( "groupedDataTemp                   : " , groupedDataTemp                 )
    console.log ( "completedGroupData                : " , completedGroupData              )
    console.log ( "statsResult                       : " , statsResult                     )
    console.log ( "chartDataTemp                     : " , chartDataTemp                   )

    const now               = new Date ();
    const currentMonthStart = new Date (now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

    let periodStartDate = startDate ?? currentMonthStart
    let periodEndDate   = endDate   ?? now

    const temp = computeActivityEvolution ( computeActivity ( filteredUrlRedirectionEventList ) ,
                                                                     timeStep                          ,
		                                                             periodStartDate                   ,
						                                             periodEndDate                     )

    const chart = temp.map ( d => {

      return {
        group: getRenderer ( d.date ),
        series: [ { name: 'data', value: d.activity } ]
      };
    });

    setGroupedData ( completedGroupData )
    setChartData (chart) // (chartDataTemp)

  }, [filteredUrlRedirectionEventList]);

  useEffect(() => {
	  
    const groupedDataTemp    = groupData<UrlRedirectionEvent> (filteredUrlRedirectionEventList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<UrlRedirectionEvent>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<UrlRedirectionEvent>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<UrlRedirectionEvent> ( completedGroupData , () => 1 , (a, b) => a + b );
    const chartDataTemp = generateChartData<UrlRedirectionEvent> ( statsResult, completedGroupData);

    setGroupedData ( completedGroupData )
    setChartData (chartDataTemp)

    console.log (timeStep, groupedDataTemp,completedGroupData,chartDataTemp)

  }, [timeStep]);
  
  

  const handleDateRangeChange = (start: string, end: string) => {

    const date1 = convertStringToDate (start,'dd/MM/yyyy HH:mm');
    const date2 = convertStringToDate (end  ,'dd/MM/yyyy HH:mm');

    setStartDate (date1);
    setEndDate   (date2);
  };

  const handleTimeStepChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setTimeStep(e.target.value);
  };

  const filterUrlRedirectionEvent = ( filterName: string): UrlRedirectionEvent[] => {
	  
    let filteredUrlRedirectionEventList = urlRedirectionEventList;

    if (filterName !== "") 
	 {

      // filteredSessionList = replaySessionList.filter(
        // (replaySession) =>
          // replaySession.userId.toString().toLowerCase().includes(filterTextLowerCase) ||
          // replaySession.userEmail.toLowerCase().includes(filterTextLowerCase) ||
          // replaySession.userFirstname.toLowerCase().includes(filterTextLowerCase) ||
          // replaySession.userLastname.toLowerCase().includes(filterTextLowerCase) 
      // );
    }

    return filteredUrlRedirectionEventList;
  };

  const handleFilterNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	  
    const newFilterName = e.target.value;
    setFilterName (newFilterName);
    setFilteredUrlRedirectionEventList (filterUrlRedirectionEvent(newFilterName));
  };

  const handleRefresh = () => {
    fetchUrlRedirectionList({ beginningDate: startDate || undefined, endingDate: endDate || undefined });
  };

  let columns = [
    { header: "Date"       , accessor: "eventDate"             as keyof UrlRedirectionEvent , width: '120px', cellRenderer: (value: any) => ( <span>{convertDateToString(value as Date,'dd/MM/yyyy HH:mm:ss') }</span> ) },

  ];

  const generateBarGraphTitle = () : string => {

   return `Nombre de vues en replay`
  }

  const generateBarGraphSubTitle = () : string => {

    const date1 = convertDateToString (startDate ,'dd/MM/yyyy HH:mm')
    const date2 = convertDateToString (endDate   ,'dd/MM/yyyy HH:mm')

    let timeStepTitle : string = ""

    for (let i =0; i<timeStepNames.length ; i++)
     {
      if ( timeStep === timeStepNames [i] )
       {
        timeStepTitle = timeStepTitles [i]
        break;
       }
     }

   return `Du ${date1} au ${date2} ${timeStepTitle}`
  }

  return (

    <div className={classNames(styles.root)}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}
	  
	  {/*
	   eventToShow !== 0 &&
	   (
  	    <Box width="95vw" height="95vh" onClose={handleClose} logo={true}>
          <UserInformations2 userId={userToShow} />
        </Box>
       )
     */}
	  
      <CustomerFrontEventList key                    = { `${timeStep}`                                     }
                              startDate              = { convertDateToString(startDate,'dd/MM/yyyy HH:mm') }
                              endDate                = { convertDateToString(endDate,'dd/MM/yyyy HH:mm')   }
                              filterName             = { filterName                                        }
                              timeStep               = { timeStep                                          }
                              sessions               = { filteredUrlRedirectionEventList                   }
                              coords                 = { coordinates                                       }
                              columns                = { columns                                           }
                              handleRefresh          = { handleRefresh                                     }
                              handleDateRangeChange  = { handleDateRangeChange                             }
                              handleFilterNameChange = { handleFilterNameChange                            }
                              handleTimeStepChange   = { handleTimeStepChange                              }
                              groupedData            = { groupedData                                       }
                              chartData              = { chartData                                         }
                              barGraphTitle          = { generateBarGraphTitle()                           }
                              barGraphSubTitle       = { generateBarGraphSubTitle()                        }
                              height                 = { height                                            }
                              ready                  = { !showWaitingIcon                                  }
                    />

    </div>
  );
};

export default RedirectionStats;

                              
